import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 text-xs font-medium text-accent-400 mb-3">
            <i className="ri-chat-heart-line"></i>
            真实反馈
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">用户口碑</h2>
          <p className="mt-2 text-sm text-foreground-500">听听影迷朋友们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentsData.map((item) => (
            <div
              key={item.id}
              className="p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/60"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-500/15 text-primary-400 font-heading font-bold text-lg flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between flex-wrap gap-2">
                    <div>
                      <div className="text-sm font-semibold text-foreground-800">{item.name}</div>
                      <div className="text-xs text-foreground-500">
                        看过 <span className="text-primary-400">{item.movie}</span> · {item.date}
                      </div>
                    </div>
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: item.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-xs text-primary-400"></i>
                      ))}
                    </div>
                  </div>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}